import type { SVGProps } from 'react';

const SvgGoogleLogo = (props: SVGProps<SVGSVGElement>) => (
  <svg fill="none" height={16} viewBox="0 0 16 16" width={16} xmlns="http://www.w3.org/2000/svg" {...props}>
    <g clipPath="url(#clip0_20_20094)">
      <path
        d="M15.041 8.1665C15.041 7.6465 14.9943 7.1465 14.9076 6.6665H8.00098V9.5065H11.9476C11.7743 10.4198 11.2543 11.1932 10.4743 11.7132V13.5598H12.8543C14.241 12.2798 15.041 10.3998 15.041 8.1665Z"
        fill="#4285F4"
      />
      <path
        d="M8.00077 15.3332C9.98077 15.3332 11.6408 14.6799 12.8541 13.5599L10.4741 11.7132C9.82077 12.1532 8.98743 12.4199 8.00077 12.4199C6.0941 12.4199 4.4741 11.1332 3.8941 9.3999H1.4541V11.2932C2.66077 13.6866 5.1341 15.3332 8.00077 15.3332Z"
        fill="#34A853"
      />
      <path
        d="M3.89366 9.39289C3.74699 8.95289 3.66033 8.48622 3.66033 7.99956C3.66033 7.51289 3.74699 7.04622 3.89366 6.60622V4.71289H1.45366C0.953659 5.69956 0.666992 6.81289 0.666992 7.99956C0.666992 9.18622 0.953659 10.2996 1.45366 11.2862L3.35366 9.80622L3.89366 9.39289Z"
        fill="#FBBC05"
      />
      <path
        d="M8.00077 3.5865C9.08077 3.5865 10.0408 3.95984 10.8074 4.67984L12.9074 2.57984C11.6341 1.39317 9.98077 0.666504 8.00077 0.666504C5.1341 0.666504 2.66077 2.31317 1.4541 4.71317L3.8941 6.6065C4.4741 4.87317 6.0941 3.5865 8.00077 3.5865Z"
        fill="#EA4335"
      />
    </g>
    <defs>
      <clipPath id="clip0_20_20094">
        <rect fill="white" height={16} width={16} />
      </clipPath>
    </defs>
  </svg>
);
export default SvgGoogleLogo;
